import React, { Component } from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'
import EamcetPractiseTestSection from '../components/eamcet_practise_test/EamcetPractiseTestSection';
import * as Cookies from "es-cookie";

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import PreloaderTwo from '../components/preloader/PreloaderTwo';

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';
import ShimmerLoader from '../components/preloader/ShimmerLoader';


// const FETCH_EAMCETPRATICETEST = gql` 
// query($mobile: String,$exam_type:Int) {
//     getEamcetPracticeTests(mobile: $mobile,exam_type: $exam_type){
//         chapter_id
//         class_id
//         subject_id
//         chapter_name
//         exam_paper_one{
//             id
//             exam_name
//             exam_type
//             exam_model_id
//             class_id
//             exam_session_id
//             sub_exam_type
//             start_time
//             end_time
//             is_completed
//             speed
//             accuracy
//             correct_marks
//             negative_marks
//             total_marks
//             exam_started
//             exam_expired
//             syllabus
//             exam_duration
//             uid
//             is_scheduled
//             is_registered
//             syllabus_desc
//             is_started
//             is_started_mobile
//             exam_duration_min
//             complexity_id
//             enabled
//         }

//    }
// }

// `;

const UPDATE_STUDENT_ANALYTICS = gql`
mutation(
  $params:AnalyticsStudents1  
  ) {
      studentAnalytics(
      params: $params
   )
}
`;

const GET_SUBJECTS = gql`

query($exam_id:Int){
getSubjectOrder(exam_id:$exam_id){
    id
    subject
}
}

`
const GET_CHAPTER_NAMES = gql`
query($exam_id:Int,$mobile:String){
    getStateChapterNames(exam_id:$exam_id,mobile:$mobile){
        id
        subject_name
        state_chapters{
            id
          chapter_id
          class_id
          chapter_name
          enabled
          questionsCount

           previousChapterEnabled
          practiceEnabled
          revisionMaterialEnabled
          errorExamEnabled       
 }
      }
}
`;

class EamcetPractiseTest extends Component {
    constructor(props) {
        super(props)
        this.state = {
            headerBottomImg: {
                type: "eamcet_view",
                title: "PRACTICE SESSIONS"
            },
            toggled: "wrapper sidebar-enable",
            submitError: ""

        }

    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    componentDidMount = () => {

        this.addStudentAnalytics();

        const title = GoogleAnalyticsArray[0].Eamcet_Practice_Tests;
        ReactGA.pageview('/student/practise_test', ["rizee"], title);
    }
    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            mobile: Cookies.get("mobile"),
            analytics_module_page_id: 111,
            source: 2

        }
        //console.log("addStudentObj", addStudentObj)

        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };

    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");


        // const getEamcetPracticeTests = this.props.getEamcetPracticeTests;
        // const loading1 = getEamcetPracticeTests.loading;
        // const error1 = getEamcetPracticeTests.error;

        const getSubjectOrder = this.props.getSubjectOrder
        const loading2 = getSubjectOrder.loading;
        const error2 = getSubjectOrder.error;

        const getStateChapterNames = this.props.getStateChapterNames
        const loading3 = getStateChapterNames.loading;
        const error3 = getStateChapterNames.error;

        // if (error1 !== undefined) {
        //     alert("Server Error. " + error1.message);
        //     return null;
        // }
        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        let globalsubjects = "";
        if (JSON.parse(localStorage.getItem("globalsubjects")) != "") {
            globalsubjects = JSON.parse(localStorage.getItem("globalsubjects"));
        }
        else {
            this.props.history.push("/student/login");
        }

        let studentGlobals = "";
        if (JSON.parse(localStorage.getItem("studentglobals")) != "") {
            studentGlobals = JSON.parse(localStorage.getItem("studentglobals"));
        }
        else {
            this.props.history.push("/student/login");
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars
                        headerBottom={this.state.headerBottomImg}
                        onClick={() => this.menuToggler()}
                    />                 </div>
                <div className="main-wrapper">
                    {/* {(loading1 == true) && (<PreloaderTwo />)} */}
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper" style={{ paddingTop: 10, minHeight: "80vh", backgroundColor: "#f6f7fb" }}>
                        {
                         loading2 || loading3 ?
                                (
                                    <Container>
                                        <Row>
                                            <Col sm={12}>
                                                <ShimmerLoader />
                                            </Col>
                                        </Row>
                                    </Container>
                                )
                                :
                                (
                                    <EamcetPractiseTestSection
                                        globalsubjects={globalsubjects}
                                        // getEamcetPracticeTests={getEamcetPracticeTests.getEamcetPracticeTests}
                                        getSubjectOrder={getSubjectOrder.getSubjectOrder}
                                        getStateChapterNames={getStateChapterNames.getStateChapterNames}
                                    />
                                )
                        }

                    </div>
                </div>
            </div>
        )
    }
}



export default withRouter(compose(
    // graphql(FETCH_EAMCETPRATICETEST,
    //     {
    //         options: props => ({
    //             variables: {
    //                 mobile: Cookies.get("mobile"),
    //                 exam_type: parseInt(Cookies.get("examid"))
    //             }
    //             ,
    //             fetchPolicy: "network-only"
    //         }), name: "getEamcetPracticeTests"
    //     }),
    graphql(UPDATE_STUDENT_ANALYTICS, {
        name: "submitpt"
    }),
    graphql(GET_SUBJECTS, {
        options: props => ({
            variables: {
                exam_id: parseInt(Cookies.get("examid")),
            },
            fetchPolicy: 'network-only'
        }), name: "getSubjectOrder"
    }),
    graphql(GET_CHAPTER_NAMES, {
        options: props => ({
            variables: {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: (Cookies.get("mobile")),

            },
            fetchPolicy: 'network-only'
        }), name: "getStateChapterNames"
    }),
)(EamcetPractiseTest));
